module.exports = __webpack_public_path__ + "img/huwelijksdrukwerk-drukwerk-annonce-trouwen-hannah-kyle-preeg-emboss-origami-1.36903822.jpg";